import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "input-group input-group-1-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- bitte auswählen --", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = ["disabled", "required"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Standorte", -1)
const _hoisted_14 = {
  key: 0,
  class: "locations"
}
const _hoisted_15 = { class: "number" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "delete" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "new-location" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 1 }

import AppActivity from "@/components/AppActivity.vue";
import {useStore} from "vuex";
import {ICON_ADD, ICON_CANCEL, ICON_OK, ICON_TRASH} from "@/lib/icons";
import {useRouter} from "vue-router";
import {computed, ref, watch} from "vue";
import {User} from "@/api/types";
import GdprCheckbox from "@/components/login/GdprCheckbox.vue";
import GdprText from "@/components/login/GdprText.vue";
import getDb from "@/db/Database";
import MembershipEntity from "@/db/Membersip";
import {hideSpinner, showAlert, showSpinner} from "@/store";
import {useApiClient} from "@/api";
import Membership from "@/api/types/Membership";
import Location from "@/api/types/Location";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileActivity',
  setup(__props) {

const store = useStore()
const router = useRouter()
const db = getDb()

const icons = [
    ICON_OK,
    ICON_CANCEL,
]

const memberships = ref<Membership[]>([])
const disabled = ref<boolean>(false)

// @ts-ignore
const data = ref<User>({
  locations: []
})
const gdprChecked = ref<boolean>(false)
const formGotValidated = ref<boolean>(false)
const membershipNrMandatory = ref<boolean>(true)

const isRegistration = ref<boolean>(true)

const newLocation = ref<object>({
  registrationNr: null,
  name: '',
})

const form = ref<HTMLFormElement|null>(null)

const configuration = computed(() => store.state.configuration)

if (configuration.value?.user) {
  // @ts-ignore
  data.value = { ...configuration.value.user }
  isRegistration.value = false
}

// @ts-ignore
if (!data.value.membershipId) {
  // @ts-ignore
  data.value.membershipId = ''
}

if (router.currentRoute.value.name === 'profile' && !configuration.value) {
  router.push({ name: 'login' })
}

if (router.currentRoute.value.name === 'signup' && configuration.value) {
  router.push({ name: 'profile' })
}

const checkMembershipNrMandatory = (id: number) => {
  const membership = memberships.value.find(m => m.id === id)
  if (membership && membership.numberMandatory !== null) {
    membershipNrMandatory.value = membership.numberMandatory > 0
  }
}

const removeLocation = (identifier: string) => {
  const [ number, name ] = identifier.split('||')
  data.value.locations = data.value.locations.filter((l: Location) => l.registrationNr !== parseInt(number) || l.name !== name)
}

const addLocation = () => {
  data.value.locations = [
    ...data.value.locations,
    {...newLocation.value}
  ]
  newLocation.value = {
    registrationNr: null,
    name: ''
  }
}

const newLocationValid = computed<boolean>(() => {
  return newLocation.value.registrationNr
      && newLocation.value.registrationNr > 0
      && newLocation.value.name.length > 0
})

;(async () => {
  showSpinner()
  let membershipEntries = await MembershipEntity.getAll(db)

  if (!membershipEntries.length) {
    if (store.state.offline.isOffline) {
      hideSpinner()
      await showAlert('Sie müssen bei erstmaliger Verwendung dieses Formulars online sein', 'Offline')
      await router.push({ name: 'login' })
    }

    const api = useApiClient()
    const membershipResponse = await api.getMemberships()

    for (const membership of membershipResponse.memberships) {
      await MembershipEntity.persist(db, membership)
      membershipEntries.push(membership)
    }
  }

  memberships.value = membershipEntries
  if (data.value.membershipId) {
    checkMembershipNrMandatory(data.value.membershipId)
  }
  hideSpinner()
})()

watch(() => data.value.membershipId, (id) => {
  if (id) {
    checkMembershipNrMandatory(id)
  }
}, { immediate: true })

const onSubmit = async () => {
  const api = useApiClient()

  showSpinner()
  try {
    if (isRegistration.value) {
      await api.saveRegistration(data.value)
      hideSpinner()
      await showAlert('Die Registrierung war erfolgreich! Sie erhalten in Kürze eine E-Mail mit dem Passwort, mit dem Sie sich anmelden können!')
      await router.push({ name: 'login' })
    } else {
      await api.updateRegistration(store.state.configuration?.sessionId, data.value)
      hideSpinner()
      await showAlert('Ihre Daten wurden erfolgreich aktualisiert')
    }
  } catch (e: any) {
    hideSpinner()
    await showAlert(e.message)
  }
}

const onIconClick = (icon: string) => {
  switch (icon) {
    case ICON_OK:
      const valid = form.value?.checkValidity()
      if (valid) {
        onSubmit()
      } else {
        showAlert('Bitte korrigieren Sie die rot markierten Felder', 'Validierung fehlgeschlagen')
        formGotValidated.value = true
      }
      break
    case ICON_CANCEL:
      router.push({ name: 'login' })
      break
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    icons: icons,
    onIconClick: onIconClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: _normalizeClass(["form profile-form", { validated: formGotValidated.value }]),
        onSubmit: _withModifiers(onSubmit, ["prevent"]),
        ref_key: "form",
        ref: form
      }, [
        _createElementVNode("label", null, [
          _createTextVNode(" Nachname "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.lastname) = $event)),
            disabled: disabled.value,
            required: ""
          }, null, 8, _hoisted_2), [
            [_vModelText, data.value.lastname]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Vorname "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.firstname) = $event)),
            disabled: disabled.value,
            required: ""
          }, null, 8, _hoisted_3), [
            [_vModelText, data.value.firstname]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Adresse "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.address) = $event)),
            disabled: disabled.value,
            required: ""
          }, null, 8, _hoisted_4), [
            [_vModelText, data.value.address]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" PLZ/Ort "),
          _createElementVNode("span", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.zip) = $event)),
              disabled: disabled.value,
              required: ""
            }, null, 8, _hoisted_6), [
              [_vModelText, data.value.zip]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.city) = $event)),
              disabled: disabled.value,
              required: ""
            }, null, 8, _hoisted_7), [
              [_vModelText, data.value.city]
            ])
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" E-Mail Adresse "),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.email) = $event)),
            disabled: disabled.value,
            required: ""
          }, null, 8, _hoisted_8), [
            [_vModelText, data.value.email]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Mitgliedschaft "),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.membershipId) = $event)),
            required: ""
          }, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberships.value, (membership) => {
              return (_openBlock(), _createElementBlock("option", {
                value: membership.id,
                key: membership.id
              }, _toDisplayString(membership.name), 9, _hoisted_10))
            }), 128))
          ], 512), [
            [_vModelSelect, data.value.membershipId]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Mitgliedsnummer "),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.membershipNumber) = $event)),
            disabled: disabled.value,
            required: membershipNrMandatory.value
          }, null, 8, _hoisted_11), [
            [_vModelText, data.value.membershipNumber]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Benutzername "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.username) = $event)),
            disabled: disabled.value,
            required: ""
          }, null, 8, _hoisted_12), [
            [_vModelText, data.value.username]
          ])
        ]),
        _hoisted_13,
        (data.value.locations && data.value.locations.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.locations, (location, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(location.registrationNr), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(location.name), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      onClick: () => removeLocation(`${location.registrationNr}||${location.name}`)
                    }, [
                      _createElementVNode("img", { src: _unref(ICON_TRASH) }, null, 8, _hoisted_19)
                    ], 8, _hoisted_18)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newLocation.value.registrationNr) = $event)),
              disabled: disabled.value,
              placeholder: "LFBIS-Nummer"
            }, null, 8, _hoisted_22), [
              [_vModelText, newLocation.value.registrationNr]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newLocation.value.name) = $event)),
              disabled: disabled.value,
              placeholder: "Standortbezeichnung"
            }, null, 8, _hoisted_23), [
              [_vModelText, newLocation.value.name]
            ]),
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[11] || (_cache[11] = () => addLocation()),
              class: _normalizeClass({ disabled: !newLocationValid.value })
            }, [
              _createElementVNode("img", { src: _unref(ICON_ADD) }, null, 8, _hoisted_24)
            ], 2)
          ])
        ]),
        (!configuration.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(GdprCheckbox, {
                modelValue: gdprChecked.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((gdprChecked).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(GdprText)
            ]))
          : _createCommentVNode("", true)
      ], 42, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})